import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../services/api';

const VerifyEmail = () => {
  const [status, setStatus] = useState('Verifying...');
  const { token } = useParams(); // Get the token from the URL

  useEffect(() => {
    const verifyAccount = async () => {
      try {
        // Call the backend route we just created
        await api.put(`/auth/verify/${token}`);
        setStatus('success');
      } catch (err) {
        setStatus('error');
      }
    };

    verifyAccount();
  }, [token]);

  if (status === 'Verifying...') {
    return <h2 style={{ textAlign: 'center', marginTop: '50px' }}>Verifying your email...</h2>;
  }

  if (status === 'error') {
    return (
      <div style={{ textAlign: 'center', marginTop: '50px', color: 'red' }}>
        <h2>Verification Failed</h2>
        <p>The link may be invalid or expired.</p>
        <Link to="/register">Back to Register</Link>
      </div>
    );
  }

  return (
    <div style={{ textAlign: 'center', marginTop: '50px', color: 'green' }}>
      <h2>Email Verified Successfully! 🎉</h2>
      <p>You can now log in to your account.</p>
      <Link to="/login" style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>Go to Login</Link>
    </div>
  );
};

export default VerifyEmail;